import { useEffect, useState } from "react";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import { RequestAgendamentoContato } from "types/request/RequestAgendamentoContato";
import { useAgendamentoContatoContext } from "context/gestaoCobranca/AgendamentoContatoContext";
import { useGetAgendamentosContatosRealizados } from "hooks/agendamentoContato/useGetAgendamentosContatosPaginados";
import { RenderRowsAgendamentos } from "./RenderRowsAgendamentos";
import { formatarDataParaGetRequest } from "shared/util/functions/formatacoesDeValores/FormatarValores";

const TabelaAgendamentosContatos = () => {
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>(
    "dataAgendamento,horarioAgendamento"
  );
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("DESC");
  const [sortString, setSortString] = useState<string>("dataAgendamento,horarioAgendamento,DESC");
  const [paginaAtual, setPaginaAtual] = useState(1);

  const { condominioId, dataAgendamento, tipoStatusAgendamento, unidadeSacadoQuery } =
    useAgendamentoContatoContext();

  useEffect(() => {
    setPaginaAtual(1);
  }, [condominioId, dataAgendamento, tipoStatusAgendamento, unidadeSacadoQuery]);

  const params: RequestAgendamentoContato = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
    condominioId: condominioId,
    dataAgendamento: formatarDataParaGetRequest(dataAgendamento),
    tipoStatusAgendamentoContato: tipoStatusAgendamento,
    unidadeSacado: unidadeSacadoQuery,
  };
  const { data: agendamentos, isFetching } = useGetAgendamentosContatosRealizados(params);

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "unidade.condominio.pessoaJuridica.nomeFantasia",
        label: "Condomínio",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "dataAgendamento,horarioAgendamento",
        label: "Data do agendamento",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "unidadeSacado",
        label: "Unidade / Sacado",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "nomeResponsavel",
        label: "Responsável",
        isOrdenavel: true,
        width: "130px",
      },
      {
        id: "tipoStatusAgendamentoContato",
        label: "Status",
        isOrdenavel: false,
        width: "150px",
        textAlign: "center",
      },
      {
        id: "acoes",
        label: "",
        isOrdenavel: false,
        width: "130px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC"
        ? "ASC"
        : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  return (
    <Tabela
      id="tabela-agendamentos"
      colunas={createColumns()}
      ordernarPorColuna={ordenarPorColuna}
      ordenacaoAscOuDesc={ordenacaoAscOuDesc}
      ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
      onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
      paginaAtual={paginaAtual}
      quantidadeDePaginas={agendamentos?.totalPages ?? 0}
      renderCheckBox={false}
      isLoading={isFetching}
      quantidadeDeRegistros={agendamentos?.totalElements ?? 0}
    >
      <RenderRowsAgendamentos registros={agendamentos?.content || []} />
    </Tabela>
  );
};

export default TabelaAgendamentosContatos;
